// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Buy Signals Page */
.signals-container {
  width: 100%;
  padding: 0 12px;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.signals-loading {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 27, 35, 0.85);
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.signals-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  flex-shrink: 0;
}

.signals-header h2 {
  margin: 0;
  color: #e2e8f0;
  font-size: 16px;
  font-weight: 600;
}

.signals-count {
  background: rgba(99, 102, 241, 0.15);
  color: #a5b4fc;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.signals-legend {
  color: #64748b;
  font-size: 11px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.signals-error {
  background: rgba(248, 113, 113, 0.1);
  color: #f87171;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
}

.signals-error button {
  background: none;
  border: none;
  color: #f87171;
  cursor: pointer;
  font-size: 16px;
}

/* Table wrapper */
.signals-table-wrapper {
  flex: 1 1;
  overflow-y: auto;
  padding-top: 4px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

.signals-table-wrapper::-webkit-scrollbar {
  width: 5px;
}

.signals-table-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

/* Table */
.signals-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.signals-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.signals-table th {
  background: #22232b;
  color: #94a3b8;
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 8px 8px;
  text-align: right;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  white-space: nowrap;
}

.signals-table th.col-rank,
.signals-table th.col-sym,
.signals-table th.col-sector {
  text-align: left;
}

.signals-table td {
  padding: 7px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: #cbd5e1;
}

.signals-table tbody tr {
  transition: background 0.1s ease;
}

.signals-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04);
}

.signals-table tbody tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.02);
}

/* Columns */
.col-fav {
  width: 28px;
  text-align: center !important;
  padding: 0 !important;
}

.fav-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #334155;
  transition: all 0.15s ease;
  padding: 2px;
  line-height: 1;
}

.fav-btn:hover {
  color: #fbbf24;
  transform: scale(1.2);
}

.fav-btn.active {
  color: #fbbf24;
}

.col-rank {
  text-align: left !important;
  color: #64748b !important;
  font-weight: 500;
  width: 30px;
}

.col-sym {
  text-align: left !important;
  font-weight: 700 !important;
  color: #e2e8f0 !important;
}

.col-sector {
  text-align: left !important;
  color: #94a3b8 !important;
  font-size: 11px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-price {
  font-weight: 600;
  color: #e2e8f0 !important;
}

.col-chg {
  font-weight: 600;
}

.col-vol {
  color: #94a3b8 !important;
}

.col-min22 {
  color: #e2e8f0 !important;
}

.col-breadth {
  color: #94a3b8 !important;
}

/* Score */
.col-score {
  font-weight: 700;
  font-size: 13px;
}

.score-excellent {
  color: #4ade80 !important;
  text-shadow: 0 0 8px rgba(74, 222, 128, 0.3);
}

.score-good {
  color: #a3e635 !important;
}

.score-fair {
  color: #fbbf24 !important;
}

.score-weak {
  color: #94a3b8 !important;
}

/* Text colors */
.text-green {
  color: #4ade80 !important;
}

.text-red {
  color: #f87171 !important;
}

.text-neutral {
  color: #64748b !important;
}

/* Responsive */
@media (max-width: 768px) {
  .signals-table {
    font-size: 11px;
  }

  .signals-table th,
  .signals-table td {
    padding: 6px 4px;
  }

  .col-sector {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BuySignals.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Buy Signals Page */\n.signals-container {\n  width: 100%;\n  padding: 0 12px;\n  position: relative;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.signals-loading {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(26, 27, 35, 0.85);\n  z-index: 9999;\n  backdrop-filter: blur(4px);\n}\n\n.signals-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  flex-shrink: 0;\n}\n\n.signals-header h2 {\n  margin: 0;\n  color: #e2e8f0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.signals-count {\n  background: rgba(99, 102, 241, 0.15);\n  color: #a5b4fc;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.signals-legend {\n  color: #64748b;\n  font-size: 11px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.signals-error {\n  background: rgba(248, 113, 113, 0.1);\n  color: #f87171;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 8px 0;\n}\n\n.signals-error button {\n  background: none;\n  border: none;\n  color: #f87171;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n/* Table wrapper */\n.signals-table-wrapper {\n  flex: 1;\n  overflow-y: auto;\n  padding-top: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n.signals-table-wrapper::-webkit-scrollbar {\n  width: 5px;\n}\n\n.signals-table-wrapper::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n/* Table */\n.signals-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.signals-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.signals-table th {\n  background: #22232b;\n  color: #94a3b8;\n  font-weight: 600;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  padding: 8px 8px;\n  text-align: right;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  white-space: nowrap;\n}\n\n.signals-table th.col-rank,\n.signals-table th.col-sym,\n.signals-table th.col-sector {\n  text-align: left;\n}\n\n.signals-table td {\n  padding: 7px 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  color: #cbd5e1;\n}\n\n.signals-table tbody tr {\n  transition: background 0.1s ease;\n}\n\n.signals-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.signals-table tbody tr:nth-child(even) {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n/* Columns */\n.col-fav {\n  width: 28px;\n  text-align: center !important;\n  padding: 0 !important;\n}\n\n.fav-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #334155;\n  transition: all 0.15s ease;\n  padding: 2px;\n  line-height: 1;\n}\n\n.fav-btn:hover {\n  color: #fbbf24;\n  transform: scale(1.2);\n}\n\n.fav-btn.active {\n  color: #fbbf24;\n}\n\n.col-rank {\n  text-align: left !important;\n  color: #64748b !important;\n  font-weight: 500;\n  width: 30px;\n}\n\n.col-sym {\n  text-align: left !important;\n  font-weight: 700 !important;\n  color: #e2e8f0 !important;\n}\n\n.col-sector {\n  text-align: left !important;\n  color: #94a3b8 !important;\n  font-size: 11px;\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.col-price {\n  font-weight: 600;\n  color: #e2e8f0 !important;\n}\n\n.col-chg {\n  font-weight: 600;\n}\n\n.col-vol {\n  color: #94a3b8 !important;\n}\n\n.col-min22 {\n  color: #e2e8f0 !important;\n}\n\n.col-breadth {\n  color: #94a3b8 !important;\n}\n\n/* Score */\n.col-score {\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.score-excellent {\n  color: #4ade80 !important;\n  text-shadow: 0 0 8px rgba(74, 222, 128, 0.3);\n}\n\n.score-good {\n  color: #a3e635 !important;\n}\n\n.score-fair {\n  color: #fbbf24 !important;\n}\n\n.score-weak {\n  color: #94a3b8 !important;\n}\n\n/* Text colors */\n.text-green {\n  color: #4ade80 !important;\n}\n\n.text-red {\n  color: #f87171 !important;\n}\n\n.text-neutral {\n  color: #64748b !important;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .signals-table {\n    font-size: 11px;\n  }\n\n  .signals-table th,\n  .signals-table td {\n    padding: 6px 4px;\n  }\n\n  .col-sector {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
